import { render } from "./WelcomeToReporting.vue?vue&type=template&id=083f5f58"
import script from "./WelcomeToReporting.vue?vue&type=script&lang=js"
export * from "./WelcomeToReporting.vue?vue&type=script&lang=js"

import exportComponent from "/srv/guestwaiterreportingfront/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__